'use client';

import React from 'react';
import { Box, Typography, Grid, Card, CardContent, CardActions, Button } from '@mui/material';
import Link from 'next/link';
import { Icon } from '@iconify/react';
import { useSession } from 'next-auth/react';
import { freeTools } from '../../lib/toolsData';

export default function ToolsIndexPage() {
  const { data: session } = useSession();
  const toolsToShow = session?.user ? freeTools : freeTools.filter((t) => t.id !== 'my-content');
  return (
    <Box component="main" id="main-content" sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>Free Tools</Typography>
      <Grid container spacing={3}>
          {toolsToShow.map((tool) => (
              <Grid item xs={12} sm={6} md={4} key={tool.id}>
                <Card>
                  <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <Box sx={{ width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', color: tool.color }}>
                      {tool.icon ? <Icon icon={tool.icon} width={32} height={32} /> : null}
                    </Box>
                    <Box>
                      <Typography variant="h6">{tool.label}</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>{tool.description}</Typography>
                    </Box>
                  </CardContent>
                  <CardActions>
                    <Link href={tool.path} passHref>
                      <Button size="small">Open</Button>
                    </Link>
                  </CardActions>
                </Card>
              </Grid>
          ))}
        </Grid>
    </Box>
  );
}
